import Categories from "@/views/admin/category/Categories";

export default {
  path: "products/categories",
  name: "categories",
  component: Categories,
  props: true,
  meta: {
    requiresAuth: true
  }
};
